import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "collection-gallery" }
const _hoisted_2 = {
  key: 0,
  class: "collection-gallery__main"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "collection-gallery__image-wrapper" }
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "gallery-item__plus" }
const _hoisted_8 = {
  key: 1,
  class: "collection-gallery__navigation-images g-row g-row--appearance_spaced"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["srcset"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "collection-gallery__video-icon"
}
const _hoisted_13 = {
  key: 2,
  class: "collection-gallery__placeholder"
}
const _hoisted_14 = { class: "ds-aspect-ratio ds-aspect-ratio--appearance_filled ds-aspect-ratio--ratio_4x4" }
const _hoisted_15 = { class: "ds-aspect-ratio__body" }
const _hoisted_16 = { class: "image-wrapper" }
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_play = _resolveComponent("icon-play")!
  const _component_icon_plus_circle = _resolveComponent("icon-plus-circle")!
  const _component_modal_trigger = _resolveComponent("modal-trigger")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.preparedImages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_swiper, {
            onSwiper: $setup.onSwiperReady,
            onSlideChange: $setup.onSlideChange,
            modules: $setup.modules,
            keyboard: { enabled: true, onlyInViewport: true },
            loop: false,
            spaceBetween: 12,
            speed: 500,
            slidesPerView: 1,
            autoplay: { delay: 5000 },
            thumbs: { swiper: $setup.thumbsSwiper, autoScrollOffset: 1 },
            navigation: { nextEl: '.js-collection-gallery-next', prevEl: '.js-collection-gallery-prev' }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preparedImages, (item, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_modal_trigger, {
                      component: "Modals/Common/ModalLightbox",
                      classes: ['modal--size_full'],
                      images: $setup.preparedImages,
                      "initial-slide": index
                    }, {
                      default: _withCtx(({ open }) => [
                        _createElementVNode("div", {
                          class: "gallery-item",
                          onClick: _withModifiers(open, ["prevent"])
                        }, [
                          _createElementVNode("picture", _hoisted_4, [
                            (item.image_url.webp)
                              ? (_openBlock(), _createElementBlock("source", {
                                  key: 0,
                                  type: "image/webp",
                                  srcset: item.image_url.webp
                                }, null, 8, _hoisted_5))
                              : _createCommentVNode("", true),
                            _createElementVNode("img", {
                              class: "collection-gallery__main-image",
                              src: item.image_url.base
                            }, null, 8, _hoisted_6)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            (item.video_url)
                              ? (_openBlock(), _createBlock(_component_icon_play, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_icon_plus_circle, { key: 1 }))
                          ])
                        ], 8, _hoisted_3)
                      ]),
                      _: 2
                    }, 1032, ["images", "initial-slide"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          }, 8, ["thumbs"])
        ]))
      : _createCommentVNode("", true),
    ($setup.preparedImages.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preparedImages, (item, index) => {
            return (_openBlock(), _createElementBlock("picture", {
              class: _normalizeClass(["collection-gallery__navigation-image-wrapper g-cell g-cols g-cols--4 g-cols--3-md g-cols--2-xl", { 'is-active': index === $setup.swiperActiveIndex }]),
              onClick: _withModifiers(($event: any) => ($setup.swiperInstance.slideTo(index)), ["prevent"])
            }, [
              (item.image_url.webp)
                ? (_openBlock(), _createElementBlock("source", {
                    key: 0,
                    type: "image/webp",
                    srcset: item.image_url.webp
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                class: "collection-gallery__image",
                src: item.image_url.base
              }, null, 8, _hoisted_11),
              (item.video_url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_icon_play)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_9))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (!$setup.preparedImages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("picture", _hoisted_16, [
                _createElementVNode("img", {
                  class: "image-wrapper__item image-wrapper__item--fit",
                  src: $setup.placeholderImage
                }, null, 8, _hoisted_17)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}